export default __webpack_public_path__ + "static/estrutura-1-f184359fd7078a12a31b6f32cb3c802a.png";